module.exports = __webpack_public_path__ + "img/coinbase.bbbc0dad.png";